import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { api } from "@/lib/api";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Chapters } from "@/components/landing/Chapters";
import { Rooms } from "@/components/landing/Rooms";
import { AmenitiesSection } from "@/components/landing/AmenitiesSection";
import { Reviews } from "@/components/landing/Reviews";
import { Promotions } from "@/components/landing/Promotions";
import { Attractions } from "@/components/landing/Attractions";
import { Dining } from "@/components/landing/Dining";
import { VisitorGuide } from "@/components/landing/VisitorGuide";
import { LocationSection } from "@/components/landing/LocationSection";
import { Gallery } from "@/components/landing/Gallery";
import { BookingModal } from "@/components/landing/BookingModal";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  const [content, setContent] = useState(null);
  const [promotions, setPromotions] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [bookingRoom, setBookingRoom] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const anchorHandler = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -70, duration: 1.4 });
      }
    };
    document.addEventListener("click", anchorHandler);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", anchorHandler);
    };
  }, []);

  useEffect(() => {
    Promise.all([api.get("/content"), api.get("/promotions"), api.get("/photos")])
      .then(([c, p, ph]) => {
        setContent(c.data);
        setPromotions(p.data);
        setPhotos(ph.data);
      })
      .catch(() => {});
  }, []);

  const openBooking = useCallback((room = "") => {
    setBookingRoom(room);
    setBookingOpen(true);
  }, []);

  return (
    <div data-testid="landing-page">
      <Navbar hotel={content?.hotel} onEnquire={() => openBooking("")} />
      <Hero hotel={content?.hotel} onEnquire={() => openBooking("")} />
      <Marquee />
      <Chapters />
      <Rooms rooms={content?.rooms} onEnquire={openBooking} />
      <AmenitiesSection features={content?.hotel?.features} />
      <Reviews />
      <Promotions promotions={promotions} hotel={content?.hotel} />
      <Attractions attractions={content?.attractions} />
      <Dining restaurants={content?.restaurants} />
      <VisitorGuide guide={content?.guide} onEnquire={openBooking} />
      <LocationSection hotel={content?.hotel} />
      <Gallery photos={photos} />
      <Footer hotel={content?.hotel} />
      <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} room={bookingRoom} rooms={content?.rooms} hotel={content?.hotel} />
    </div>
  );
}
